import controller from './products-list.controller';
import templateT1 from './templates/products-list-t1.view.html';
import templateAD from './templates/products-list-adaptative.html';

let ProductsListComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        categorySlug: "<",
        categoryId: '<',
        productsList: '<',
        isProcedure:'<',
        typeview: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative){
      return templateAD;
    } else {
        return templateT1;
    }
}

export default ProductsListComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/products-list/products-list.component.js
 **/